// vuexをIE11で表示する。
import 'es6-promise/auto'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// Babel
import 'babel-polyfill'

// boxicons
import 'boxicons/css/boxicons.min.css'

// Utility for Cookie
import VueCookie from 'vue-cookie'

// Modal Drag
import drag from 'v-drag'

Vue.use(VueCookie)

Vue.config.productionTip = false

Vue.use(drag)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// templateからもwindow.alert(), console.log()が使用できるようglobal mixin
Vue.mixin({
  methods: {
    alert: function (arg) {
      alert(arg)
    },
    log: function (arg) {
      console.log(arg)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main/js/main.js